import styled from 'styled-components';
import AppCSS from '../../utils/styled';
import { ReactComponent as ArrowDownIcon } from '../../assets/icons/icon-arrow-down.svg';
import { DEFAULT_PICKER_WIDTH } from '../../utils/styled/dimensions';

export const Components = {
  Picker: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;
    ${AppCSS.radiuses.default};
    border: 1px solid ${AppCSS.colors.greys.medium};
    background-color: ${AppCSS.colors.white};
    overflow: hidden;
    padding: 0 12px;
    min-height: 40px;
    width: ${DEFAULT_PICKER_WIDTH}px;
    min-width: ${DEFAULT_PICKER_WIDTH}px;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    &:hover {
      border-color: ${AppCSS.colors.greys.prettyDark};
    }
    &:focus-visible {
      outline: none;
      border-color: ${AppCSS.colors.blues.primary};
      box-shadow: 0 0 0 3px ${AppCSS.colors.blues.primary}33;
    }
  `,
  PickerIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  PickerLabel: styled.span`
    flex: 1;
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.blues.veryDark};
    width: 100%;
    -webkit-line-clamp: 1; // <- you can change rows number
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  PickerIcon: styled(ArrowDownIcon)`
    height: 16px;
    width: 16px;
  `,
  NotSetLabel: styled.span`
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.greys.prettyDark};
    flex: 1;
  `,
};
